const isProd = window.location.host.indexOf('cypar-tane.com') >= 0;
const isStg = window.location.host.indexOf('stg') >= 0;

export default {
  isLogin: 0,
  needSSO: isProd || isStg
};
